import { useSearchParams } from 'react-router-dom';
import { WorkerDataProvider } from 'public/components/common/worker-data-provider';
import { CertificateUploadContent } from './certificate-upload-content';

export const CertificateUpload = () => {
  const [searchParams] = useSearchParams();
  const workerId = searchParams.get('workerId') ?? undefined;

  return (
    <WorkerDataProvider workerId={workerId}>
      {(data) => <CertificateUploadContent data={data} />}
    </WorkerDataProvider>
  );
};
